import React from 'react';
import { InlineTextButton } from '../../components';
import { FormattedMessage } from '../../util/reactIntl';

import css from './ListingPage.module.css';

const SectionAboutOperatorMaybe = props => {
  const { description, authorName, onContactUser } = props;
  return description ? (
    <div className={css.sectionDescription}>
      <h2 className={css.descriptionTitle}>
        <FormattedMessage id="ListingPage.AboutOperatorTitle" />
        &nbsp;
        <InlineTextButton className={css.descriptionTitle} onClick={onContactUser}>
          {authorName}
        </InlineTextButton>
      </h2>
    </div>
  ) : null;
};

export default React.memo(SectionAboutOperatorMaybe);
